import { NgIf } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnChanges, Output } from '@angular/core';
import { ComingSoonComponent } from '../../../../shared/components/coming-soon/coming-soon.component';
import { UserMessageResponse } from '../../copilot.model';
import { PosthogService } from '../../../../services/posthog.service';
import { PosthogEventName, PosthogEventCode } from '../../../../services/types';
import { AssetVersionPipe } from '../../../../pipes/asset-version.pipe';

@Component({
  selector: 'app-response-action-buttons',
  imports: [
    NgIf,
    ComingSoonComponent,
    AssetVersionPipe
  ],
  templateUrl: './response-action-buttons.component.html',
  styleUrl: './response-action-buttons.component.scss',
})
export class ResponseActionButtonsComponent implements OnChanges {
  private posthogService = inject(PosthogService);

  @Input() isCopySucceeded = false;
  @Input() shouldDisplayRetryButton = false;
  @Input() userResponse?: UserMessageResponse;

  @Output() copy = new EventEmitter<void>();
  @Output() share = new EventEmitter<void>();
  @Output() goodResponse = new EventEmitter<void>();
  @Output() badResponse = new EventEmitter<void>();
  @Output() retry = new EventEmitter<void>();

  isGoodResponse = false;
  isBadResponse = false;
  isResponseActionTaken = false;
  isCopyClicked = false;
  isShareHovered = false;

  ngOnChanges() {
    if (this.userResponse) {
      this.isGoodResponse = this.userResponse === UserMessageResponse.POSITIVE ? true : false;
      this.isBadResponse = this.userResponse === UserMessageResponse.NEGATIVE ? true : false;
    }
    if (this.isCopySucceeded) {
      this.isCopyClicked = false;
    }
  }

  onCopyClick(): void {
    if (this.isCopyClicked) return;
    this.isCopyClicked = true;
    this.posthogService.capture(PosthogEventName.POLARIS_MESSAGE_ACTION, {
      [PosthogEventCode.ACTION_TYPE]: 'copy'
    });
    this.copy.emit();
  }

  onShareClick(): void {
    this.share.emit();
  }

  onGoodResponseClick(): void {
    // User has already clicked one of the response buttons (form storage conversion)
    if (this.userResponse) return;
    // Prevent multiple clicks
    if (this.isResponseActionTaken) return;

    this.isGoodResponse = true;
    this.isBadResponse = false;
    this.isResponseActionTaken = true;

    this.posthogService.capture(PosthogEventName.POLARIS_MESSAGE_ACTION, {
      [PosthogEventCode.ACTION_TYPE]: 'good_response'
    });
    this.goodResponse.emit();
  }

  onBadResponseClick(): void {
    // User has already clicked one of the response buttons (form storage conversion)
    if (this.userResponse) return;
    // Prevent multiple clicks
    if (this.isResponseActionTaken) return;

    this.isBadResponse = true;
    this.isGoodResponse = false;
    this.isResponseActionTaken = true;

    this.posthogService.capture(PosthogEventName.POLARIS_MESSAGE_ACTION, {
      [PosthogEventCode.ACTION_TYPE]: 'bad_response'
    });
    this.badResponse.emit();
  }

  onRetryClick(): void {
    this.retry.emit();
  }

}